import { FormikProps } from 'formik';
import React from 'react';
import VoxelCheckbox from '../../../../components/voxel/Forms/VoxelCheckbox';
import VoxelTooltipShort from '../../../../components/voxel/Tooltip/VoxelTooltipShort';
import { CreateQuickSearchFormState } from './QuickSearchForm/logic/QuickSearchModels';
import VoxelText from '../../../../components/voxel/Text/VoxelText';

export interface LongTailCheckboxesProps {
  formik: FormikProps<CreateQuickSearchFormState>;
  validLongtailLanguage: boolean;
  helperText?: string;
  disabled?: boolean;
  showError?: boolean;
}

const LongTailCheckboxes: React.FC<LongTailCheckboxesProps> = ({
  formik,
  validLongtailLanguage,
  helperText,
  disabled,
  showError,
}) => {
  const disabledVar = formik.isSubmitting || disabled;
  const validLongtailLanguageTooltip = 'Option not available in this language';
  return (
    <div>
      <VoxelTooltipShort message={helperText} disabled={!showError}>
        <VoxelText variant='form-caption' paddingBot color={showError ? 'error' : null}>Google suggest include options *</VoxelText>
      </VoxelTooltipShort>
      <div className="grid grid-cols-2">
        {[
          {
            title: 'Keyword',
            value: formik.values.suggestionsWord,
            valueKey: 'suggestionsWord',
            tooltip: "Gets Google Search autocomplete words for '<keyword>'",
            disabledIf: false,
          },
          {
            title: 'Questions',
            value: formik.values.suggestionsQuestions,
            valueKey: 'suggestionsQuestions',
            tooltip: validLongtailLanguage
              ? "Gets Google Search autocomplete words  for '<question> <keyword>', example questions in English: which, are, when, can, how, why, will what, where, who"
              : validLongtailLanguageTooltip,
            disabledIf: !validLongtailLanguage,
          },
          {
            title: 'Alphabeticals',
            value: formik.values.suggestionsAlphabeticals,
            valueKey: 'suggestionsAlphabeticals',
            tooltip:
              "Gets Google Search autocomplete words for '<keyword> <letter>' and '<letter> <keyword>'",
            disabledIf: false,
          },
          {
            title: 'Prepositions',
            value: formik.values.suggestionsPrepositions,
            valueKey: 'suggestionsPrepositions',
            tooltip: validLongtailLanguage
              ? "Gets Google Search autocomplete words  for '<keyword> <preposition>', example prepositions in English: without, near, to, is, with, for, can"
              : validLongtailLanguageTooltip,
            disabledIf: !validLongtailLanguage,
          },
          {
            title: 'Numbers',
            value: formik.values.suggestionsNumbers,
            valueKey: 'suggestionsNumbers',
            tooltip:
              "Gets Google Search autocomplete words for '<keyword> <number>' and '<number> <keyword>'",
            disabledIf: false,
          },
          {
            title: 'Comparisons',
            value: formik.values.suggestionsComparisons,
            valueKey: 'suggestionsComparisons',
            tooltip: validLongtailLanguage
              ? "Gets Google Search autocomplete words for '<keyword> <comparison>', example comparisons in English: versus, vs, like, or, and"
              : validLongtailLanguageTooltip,
            disabledIf: !validLongtailLanguage,
          },
        ].map((item) => (
          <div key={item.valueKey} className="mr-6">
            <VoxelTooltipShort message={item.tooltip} disabled={formik.isSubmitting}>
              <span>
                <VoxelCheckbox
                  label={item.title}
                  checked={item.value}
                  onChange={() => formik.setFieldValue(item.valueKey, !item.value)}
                  disabled={disabledVar || item.disabledIf}
                  color="primary"
                  padding
                />
              </span>
            </VoxelTooltipShort>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LongTailCheckboxes;
